<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="queryCondition.isCountDirection">方向</el-checkbox>
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="queryCondition.isCountCurrencyCoin">法币</el-checkbox>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySubmit()">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="statisticInfo">
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column prop="currencyCoin" label="法币" v-if="queryCondition.isCountCurrencyCoin"></el-table-column>
            <el-table-column label="方向" v-if="queryCondition.isCountDirection">
                <template slot-scope="scope">{{scope.row.direction === 'S' ? '卖出' : scope.row.direction === 'B' ?'买入' : ''}}</template>
            </el-table-column>
            <el-table-column prop="amount" label="出入金额"></el-table-column>
            <el-table-column label="时间">
                <template slot-scope="scope">{{parseDateTime(scope.row.date)}}</template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import api from './api';
    export default {
        name: "otcStatistic",
        data(){
            return {
                time:'',
                queryCondition:{
                    startTime:'',
                    endTime:'',
                    isCountDirection: false,
                    isCountCurrencyCoin:false,
                },
                statisticInfo:[],
            }
        },
        methods:{
            querySubmit: function () {
                if (this.time) {
                    this.queryCondition.startTime = this.time[0];
                    this.queryCondition.endTime = this.time[1];
                } else {
                    let nowTime = new Date();
                    this.queryCondition.startTime = new Date(nowTime.getFullYear() - 1,nowTime.getMonth() + 1,nowTime.getDate()).getTime();
                    this.queryCondition.endTime = new Date(nowTime.getFullYear() - 1,nowTime.getMonth() + 1,nowTime.getDate() + 1).getTime();
                }
                api.queryOtcStatistic(this.queryCondition).then(response => {
                    this.statisticInfo = response.data;
                })
            },

            parseDateTime(time){
                let now = new Date(time);
                let year=now.getFullYear();
                let month=now.getMonth()+1;
                let date=now.getDate();
                let hour=now.getHours();
                let minute=now.getMinutes();
                let second=now.getSeconds();
                return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            },
        }
    }
</script>

<style scoped>

</style>